import React from "react";

import {
  ApartmentOutlined,
  TableOutlined,
  VideoCameraOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  CalendarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

export const LeftMenuData = [
  // {
  //   name: "home",
  //   label: "Accueil",
  //   icon: <HomeOutlined />,
  //   path: "/accueil-amo",
  //   key: "sub1",
  // },
  {
    name: "program",
    label: "Programmes",
    icon: <ApartmentOutlined />,
    path: "/projets",
    key: "sub2",
  },
  {
    name: "plannings",
    label: "Plannings",
    icon: <CalendarOutlined />,
    path: "/amo/plannings",
    key: "sub3",
  },
  {
    name: "currentProgram",
    label: undefined, //localStorage.getItem("currentProgram"),
    icon: <ThunderboltOutlined />,
    items: [
      // {
      //   name: "program-index",
      //   label: "Aperçu",
      //   icon: <DesktopOutlined />,
      //   path: "#top",
      //   key: "1",
      // },
      {
        name: "program-clients",
        label: "Clients",
        icon: <TableOutlined />,
        path: "/clients",
        key: "2",
      },
      // {
      //   name: "program-messages",
      //   label: "Messages",
      //   icon: <TableOutlined />,
      //   path: "/messages",
      //   key: "3",
      // },
      {
        name: "program-edit",
        label: "Plannings",
        icon: <CalendarOutlined />,
        path: "/plannings",
        key: "4",
      },
      {
        name: "program-visits",
        label: "Visites 3D",
        icon: <VideoCameraOutlined />,
        path: "/visites-3d",
        key: "5",
      },
      {
        name: "program-settings",
        label: "Paramètres",
        icon: <SettingOutlined />,
        path: "/parametres",
        key: "6",
      },
    ],
    key: "sub4",
  },
  {
    name: "templates",
    label: "Modèles",
    icon: <FileTextOutlined />,
    path: "/amo/templates",
    key: "sub5",
  },
  // {
  //   name: "visites-dashboard",
  //   label: "Visites",
  //   icon: <VideoCameraOutlined />,
  //   path: "/visites",
  //   key: "sub4",
  // },
  // {
  //   name: "currentHousing",
  //   label: localStorage.getItem("currentHousing"),
  //   icon: <ThunderboltOutlined />,
  //   items: [
  //     {
  //       name: "actualite",
  //       label: "Actualité",
  //       icon: <DesktopOutlined />,
  //       path: "#top",
  //       key: "1",
  //     },
  //     {
  //       name: "tmas",
  //       label: "TMA(s)",
  //       icon: <DesktopOutlined />,
  //       path: "/tmas",
  //       key: "2",
  //     },
  //     {
  //       name: "choix",
  //       label: "Choix",
  //       icon: <TableOutlined />,
  //       path: "/choix",
  //       key: "3",
  //     },
  //     {
  //       name: "messages",
  //       label: "Messages",
  //       icon: <CalendarOutlined />,
  //       path: "/messages",
  //       key: "4",
  //     },
  //     {
  //       name: "documents",
  //       label: "Documents",
  //       icon: <SettingOutlined />,
  //       path: "/documents",
  //       key: "5",
  //     },
  //     {
  //       name: "chantier",
  //       label: "Chantier",
  //       icon: <SettingOutlined />,
  //       path: "/chantier",
  //       key: "6",
  //     },
  //   ],
  //   key: "sub2",
  // },
];
